import { render } from "./CheckTranslation.vue?vue&type=template&id=2890d0b2&scoped=true&ts=true"
import script from "./CheckTranslation.vue?vue&type=script&lang=ts"
export * from "./CheckTranslation.vue?vue&type=script&lang=ts"

import "./CheckTranslation.vue?vue&type=style&index=0&id=2890d0b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2890d0b2"]])

export default __exports__